// src/hooks/useScrollTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useScrollTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;              // keep anchor scroll
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);                  // run only when the path really changes
}
